<form [formGroup]="formRangeGroup">
  <fieldset class="c__range-input">
    <legend>{{ 'filters.range.title' | translate}}</legend>
    <sd-form-input
      type="number"
      [class]="displayInput ? '' : 'is-visually-hidden'"
      formControlName="minSelected"
      (inputChanged)="valueChange({pointerType: pointerType.Min, value: undefined})"
      #inputMin
      [delay]="delay"
      [step]="_rangeOptions?.step"
      [min]="_rangeOptions?.minValue"
      [max]="_rangeOptions?.maxValue - _rangeOptions?.step"
      [labelTitle]="_rangeOptions?.minValueLabel"
      [labelHidden]="true"
      nameField="minRangeInput"
      [required]="_rangeOptions?.required"
    />

    <sd-form-input
      type="number"
      [class]="displayInput ? '' : 'is-visually-hidden'"
      formControlName="maxSelected"
      (inputChanged)="valueChange({pointerType: pointerType.Max, value: undefined})"
      [delay]="delay"
      #inputMax
      [min]="_rangeOptions?.minValue + _rangeOptions?.step"
      [max]="_rangeOptions?.maxValue"
      [step]="_rangeOptions?.step"
      [labelTitle]="_rangeOptions?.maxValueLabel"
      [labelHidden]="true"
      nameField="maxRangeInput"
      [required]="_rangeOptions?.required"
    />
  </fieldset>
</form>

@if (showSlider) {
  <ngx-slider
    [options]="sliderOption()"
    (userChangeEnd)="valueChange($event)"
    [(value)]="inputMinValue"
    [(highValue)]="inputMaxValue"
  />
}
